import inviteFormSubmitted from "../events/invite-form-submitted.js";
function makeEventRouter() {
    const router = {
        'invite-form-submitted': inviteFormSubmitted
    };
    return Object.freeze({
        get
    });
    function get(action) {
        return router[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
